<template>
    <div class="step-a-wrapper">
        
        <div><h3 class="mb-20" style="color: #1890ff;">MUIC Alumni Survey</h3></div>
    <a-form layout="vertical" :form="formStepF">
            
            <a-row :gutter="[16, 16]">
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">1. If people asked for your advice in choosing an institution, would you recommend Mahidol University ?</span> 
                        </template>
                        <a-select 
                            v-model="form.muicinstitution" 
                            show-search 
                            placeholder="Select..." 
                            v-decorator="[
                                'form.muicinstitution',
                                { rules: [{ required: true, message: 'Please input' }] },
                            ]"
                        >
                            <a-select-option value="strongly agree">strongly agree</a-select-option>
                            <a-select-option value="agree">agree</a-select-option>
                            <a-select-option value="neither agree nor disagree">neither agree nor disagree</a-select-option>
                            <a-select-option value="disagree">disagree</a-select-option>
                            <a-select-option value="strongly disagree">strongly disagree</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">2. What kind of activities that should be held to prepare your career ?</span> 
                        </template>
                        <a-textarea 
                            v-model="form.muicactivities" 
                            v-decorator="[
                                'form.muicactivities',
                                { rules: [{ required: true, message: 'Please input' }] },
                            ]"
                            placeholder="" 
                            rows="2" 
                        />
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">3. The most memorable experience in MUIC  ?</span> 
                        </template>
                        <a-textarea 
                            v-model="form.muicmemorable" 
                            v-decorator="[
                                'form.muicmemorable',
                                { rules: [{ required: true, message: 'Please input' }] },
                            ]"
                            placeholder="" 
                            rows="2" 
                        />
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <h5 class="font-web mt-0 mb-10">Alumni Survey</h5>
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">4. What type of activities would you prefer to join in ? (Can choose more than 1 item)</span> 
                        </template>
                        <a-checkbox-group 
                            v-model="form.muicprefer"
                            v-decorator="[
                                'form.muicprefer',
                                {
                                initialValue: form.muicprefer,
                                rules: [
                                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                                ]
                                }
                            ]"
                        >
                            <a-row :gutter="[16,16]">
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Sport Event">Sport Event</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Seminar (as an attendee or a guest speaker)">Seminar (as an attendee or a guest speaker)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Outstanding Alumni Awardee">Outstanding Alumni Awardee</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="MUIC Fairs (Job Fair, IC Fest Fair, Alumni Fair, etc.)">MUIC Fairs (Job Fair, IC Fest Fair, Alumni Fair, etc.)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Reunion">Reunion</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Volunteering, community service project or donation">Volunteering, community service project or donation</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Others">Others</a-checkbox></a-col>
                            </a-row>
                            <a-input class="mt-5" v-if="form.muicprefer.includes('Others')" v-model="form.muicpreferOther" />
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">5. What are your motivators for attending MUIC alumni events ? (Can choose more than 1 item)</span> 
                        </template>
                        <a-checkbox-group 
                            v-model="form.muicattending"
                            v-decorator="[
                                'form.muicattending',
                                {
                                initialValue: form.muicattending,
                                rules: [
                                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                                ]
                                }
                            ]"
                        >
                            <a-row :gutter="[16,16]">
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Reconnect with old friends and classmates">Reconnect with old friends and classmates</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Meet new alumni with similar interests">Meet new alumni with similar interests</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Learn about career development opportunities">Learn about career development opportunities</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Network with industry professionals">Network with industry professionals</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Support the university and current students">Support the university and current students</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Attend engaging activities (e.g., sports, games, concerts, parties)">Attend engaging activities (e.g., sports, games, concerts, parties)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Hear from interesting guest speakers">Hear from interesting guest speakers</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Others">Others</a-checkbox></a-col>
                            </a-row>
                            <a-input class="mt-5" v-if="form.muicattending.includes('Others')" v-model="form.muicattendingOther" />
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">6. What benefits would you like to receive as a member of MUIC Alumni Association ? (Can choose more than 1 item)</span> 
                        </template>
                        <a-checkbox-group 
                            v-model="form.muicbenefits"
                            v-decorator="[
                                'form.muicbenefits',
                                {
                                initialValue: form.muicbenefits,
                                rules: [
                                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                                ]
                                }
                            ]"
                        >
                            <a-row :gutter="[16,16]">
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Library access">Library access</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Special Discount for attending MUIC events">Special Discount for attending MUIC events</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Discount for MU Facilities (ex. Seminar rooms/Sport services)">Discount for MU Facilities (ex. Seminar rooms/Sport services)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Others">Others</a-checkbox></a-col>
                            </a-row>
                            <a-input class="mt-5" v-if="form.muicbenefits.includes('Others')" v-model="form.muicbenefitsOther" />
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item>
                        <template slot="label">
                            <span class="font-web font-weight-bold" style="">7. What type of media would you prefer to receive information from us ? (Can choose more than 1 item)</span> 
                        </template>
                        <a-checkbox-group 
                            v-model="form.muicreceive"
                            v-decorator="[
                                'form.muicreceive',
                                {
                                initialValue: form.muicreceive,
                                rules: [
                                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                                ]
                                }
                            ]"
                        >
                            <a-row :gutter="[16,16]">
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Website (MUIC website/MUIC Alumni Website)">Website (MUIC website/MUIC Alumni Website)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Facebook (MUIC Alumni Association/MUIC Alumni Fanpage)">Facebook (MUIC Alumni Association/MUIC Alumni Fanpage)</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="SMS">SMS</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="E-mail">E-mail</a-checkbox></a-col>
                                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Others">Others</a-checkbox></a-col>
                            </a-row>
                            <a-input class="mt-5" v-if="form.muicreceive.includes('Others')" v-model="form.muicreceiveOther" />
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
            </a-row>

        </a-form>

        <div class="text-right">
            <a-button-group>
                <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
                <a-button @click="submitAndValidateF" type="primary"> Go forward<a-icon type="right" /> </a-button>
            </a-button-group>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            formStepF: this.$form.createForm(this, { name: 'stepF' }),
            form: {
                muicinstitution: '',
                muicactivities: '',
                muicmemorable: '',
                muicprefer: [],
                muicpreferOther: '',
                muicattending: [],
                muicattendingOther: '',
                muicbenefits: [],
                muicbenefitsOther: '',
                muicreceive: [],
                muicreceiveOther: '',
            }
        };
    },
    mounted() {},
    methods: {
        backSection() {
            this.$emit('backSection')
        },
        submitAndValidateF() {
            this.formStepF.validateFields((err, values) => {
                if (!err) {
                    this.$emit('updateData', 'stepF', { ...this.form, ...values.form });
                    this.$emit('NextSectionSubmit'); // Advance to stepSubmit
                }
            });
        },
    },
};
</script>

<style scoped>
.step-a-wrapper {
    padding: 20px;
}
</style>
